<template>
  <editor :id="id" default-tab="access_group" :tabs="tabs"></editor>
</template>

<script>
import Editor from '@/components/Editor'
import AccessGroup from './editor/AccessGroup'

export default {
  props: ['id'],
  components: {
    Editor
  },
  data () {
    return {
      tabs: [
        {title: "Access group",      name: "access_group",      component: AccessGroup, admin_only: true},
      ]
    }
  }
}
</script>
